module.exports = __webpack_public_path__ + "static/media/POT EDITED.e9b88f0d.JPG";